import React, {Component} from "react";
import { Link } from "react-router-dom";
import { Row, Col,  Card, CardHeader, Container, CardBody, CardFooter, Collapse, Button} from "reactstrap";
import { DISPLAY_UI_ERRORS } from "../../constants/Constants.js";
import { serverLog } from "../../actions/actionServerLog";
import { connect } from "react-redux";

class ErrorBoundary extends Component {
  constructor(props) {
    super(props);
    this.state = { error: null, errorInfo: null };
  }

  componentDidCatch(error, errorInfo) {
      this.setState({
          error: error,
          errorInfo: errorInfo
      });
      const log = {
          message: "An unhandled client error has occurred: (" + error.message + ")",
          level: "error",
          error_name: error.name,
          error_stack: error.stack,
          error_message: error.message,
          error_component_stack: errorInfo.componentStack
      };

      this.props.serverLog(log);

      const eventData = {
          type: 'error_boundary',
          value: log,
      };
      window.parent.postMessage(eventData, '*');
  }

    render() {
        if (this.state.errorInfo) {
            return (
                <div className="app bg-image">
                    <br/>
                    <br/>
                    <Row>
                        <Col sm={{size: 10, order: 3, offset: 1}}>
                            <Card className="errorBoundary">
                                <CardHeader>
                                    <i className="fa fa-exclamation"></i> <strong>Error</strong>
                                </CardHeader>
                                <CardBody>
                                    <h2>Oops, something went wrong.</h2>
                                    <div>
                                        If the problem persists, please contact an administrator.
                                    </div>
                                    <br/>
                                    <a href="/"><Button size="sm" color="dark"> Return to Application</Button></a>
                                    <br/>
                                    <br/>
                                    {
                                        DISPLAY_UI_ERRORS ?
                                            <div style={{whiteSpace: 'pre-wrap'}}>
                                                {this.state.error && this.state.error.toString()}
                                                <br />
                                                {this.state.errorInfo.componentStack}
                                            </div>
                                            :
                                            ""
                                    }

                                </CardBody>
                            </Card>
                        </Col>
                    </Row>
                </div>
            );
        }
        // Normally, just render children
        return this.props.children;
    }
}

export default connect(state =>
    ({}),
dispatch =>
    ({
        serverLog: (log) => dispatch(serverLog(log)),

    }))(ErrorBoundary);